import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login'   // 登录页
import homePage from '@/views/homePage' // 首页
import detailInformation from '@/views/detailInformation'   // 会员简介页（红娘与其他会员查看）
// import followUpInfo from '@/views/followUpInfo'
import checkSex from '@/views/checkSex'
import detail from '@/views/detail'      //  鹊桥会详情
import matchmakerGroup from '@/views/matchmakerGroup'   // 红娘团队
import joinMatchmakerTeam from '@/views/joinMatchmakerTeam'    // 申请加入会员
import memberCenter from '@/views/memberCenter'   //  会员中心
import followUpRecords from '@/views/followUpRecords'    //  跟进记录
import editInfos from '@/views/editInfos'   //  会员编辑
import followUpPage from '@/views/followUpPage'   //  红娘查看会员详情
import matchmakerCenter from '@/views/matchmakerCenter'  //  红娘中心
import excellentMatchmaker from '@/views/excellentMatchmaker'  //  红娘详情
import activity from '@/views/activity'   //  活动中心
import joinMatchMaker from '@/views/joinMatchMaker'   //  加入红娘
import matchMakerInfo from '@/views/matchMakerInfo'  //  编辑红娘信息
import checkInterests from '@/views/checkInterests'  //  兴趣爱好描述编辑与查看
import socialActivities from '@/views/socialActivities'   //  活动详情与报名
import mutualChoice from '@/views/mutualChoice'   //  互选大厅
import memberBrowsingHistory from '@/views/memberBrowsingHistory'  //  会员进入查询会员和浏览记录
import editFiled from '@/views/editFiled'   //  会员编辑资料与红娘查看资料
import editMatchFiled from '@/views/editMatchFiled'  //  红娘查看与编辑资料
import tagSelector from '@/views/tagSelector'  //  标签选择
import emotionalStatusEdit from '@/views/emotionalStatusEdit'  //  情感状态编辑
import encounter from '@/views/encounter'  //  遇见页面
import matchmakerList from '@/views/matchmakerList'  //  红娘列表
import favoriteMatchmaker from '@/views/favoriteMatchmaker'  //  收藏的红娘列表
import myFavoriteMembers from '@/views/myFavoriteMembers'  //  我的心仪对象
import myScore from '@/views/myScore'  //  我的积分
import conversationList from '@/views/conversationList'  //  消息列表
import chatRoom from '@/views/chatRoom'  //  聊天窗口
import followUpTargetSelector from '@/views/followUpTargetSelector'  // 推荐对象选择


Vue.use(Router)

export default new Router({
  // mode: 'history', // 去掉路由里的#
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/mbc/:id',
      name: 'login',
      component: login,
    },
    {
      path: '/homePage',
      name: 'homePage',
      component: homePage,
    },
    {
      path: '/detailInformation/:id',
      name: 'detailInformation',
      component: detailInformation,
    },
    {
      path: '/checkSex',
      name: 'checkSex',
      component: checkSex,
    },
    {
      path: '/memberCenter',
      name: 'memberCenter',
      component: memberCenter,
    },
    {
      path: '/followUpRecords/:id',
      name: 'followUpRecords',
      component: followUpRecords,
    },
    {
      path: '/editInfos',
      name: 'editInfos',
      component: editInfos,
    },
    {
      path: '/editMatchFiled/:name',
      name: 'editMatchFiled',
      component: editMatchFiled,
    },
    {
      path: '/editFiled/:name',
      name: 'editFiled',
      component: editFiled,
    },
    // {
    //   path: '/editFiled/:name/:id',
    //   name: 'editFiled',
    //   component: editFiled,
    // },
    {
      
      path: '/lookFiled/:name/:id',
      name: 'lookFiled',
      component: editFiled,
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity,
    },
    {
      path: '/checkInterests',
      name: 'checkInterests',
      component: checkInterests,
    },
    {
      path: '/checkInterests/:id',
      name: 'checkInterests',
      component: checkInterests,
    },
    {
      path: '/followUpPage/:id',
      name: 'followUpPage',
      component: followUpPage,
    },
    {
      path: '/excellentMatchmaker/:id',
      name: 'excellentMatchmaker',
      component: excellentMatchmaker,
    },
    {
      path: '/excellentMatchmakerDetail/:id',
      name: 'excellentMatchmakerDetail',
      component: excellentMatchmaker,
    },
    {
      path: '/detail',
      name: 'detail',
      component: detail,
    },
    {
      path: '/matchmakerGroup',
      name: 'matchmakerGroup',
      component: matchmakerGroup,
    },
    {
      path: '/joinMatchmakerTeam',
      name: 'joinMatchmakerTeam',
      component: joinMatchmakerTeam,
    },
    {
      path: '/matchmakerCenter',
      name: 'matchmakerCenter',
      component: matchmakerCenter,
    },
    {
      path: '/joinMatchMaker',
      name: 'joinMatchMaker',
      component: joinMatchMaker
    },
    {
      path: '/matchMakerInfo',
      name: 'matchMakerInfo',
      component: matchMakerInfo
    },
    {
      path: '/socialActivities/:id',
      name: 'socialActivities',
      component: socialActivities,
    },
    {
      path: '/mutualChoice/:activityId',
      name: 'mutualChoice',
      component: mutualChoice,
    },
    {
      path: '/memberBrowsingHistory',
      name: 'memberBrowsingHistory',
      component: memberBrowsingHistory,
    },
    {
      path: '/tagSelector',
      name: 'tagSelector',
      component: tagSelector,
    },
    {
      path: '/emotionalStatusEdit',
      name: 'emotionalStatusEdit',
      component: emotionalStatusEdit,
    },
    {
      path: '/encounter',
      name: 'encounter',
      component: encounter,
    },
    {
      path: '/matchmakerList',
      name: 'matchmakerList',
      component: matchmakerList,
    },
    {
      path: '/favoriteMatchmaker',
      name: 'favoriteMatchmaker',
      component: favoriteMatchmaker,
    },
    {
      path: '/myFavoriteMembers',
      name: 'myFavoriteMembers',
      component: myFavoriteMembers,
    },
    {
      path: '/myScore',
      name: 'myScore',
      component: myScore,
    },
    // 聊天相关页面
    {
      path: '/conversationList',
      name: 'conversationList',
      component: conversationList,
    },
    {
      path: '/chatRoom/:id',
      name: 'chatRoom',
      component: chatRoom,
    },
    {
      path: '/followUpTargetSelector/:id',
      name: 'followUpTargetSelector',
      component: followUpTargetSelector,
    },
    {
      path: '/followUpRelationshipOverview',
      name: 'followUpRelationshipOverview',
      component: () => import('@/views/followUpRelationshipOverview.vue'),
      meta: { title: '跟进关系总览', role: ['Matchmaker'] }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js